import baseAPI from '@/api/base';
import { EditProject, GetProject, RegisterProject } from '@/dtos/project.dto';
import {
  DELETE_PROJECT_URL,
  EDIT_PROJECT_URL,
  GET_PROJECT_URL,
  REGISTER_PROJECT_URL,
  TOGGLE_PROJECT_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class Project {
  static getProjects = async (getProject: GetProject): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_PROJECT_URL, {
      params: getProject,
    });
    console.log('response', response);
    return response;
  };

  static registerProject = async (
    registerProject: RegisterProject
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_PROJECT_URL, {
      ...registerProject,
    });
    console.log('response', response);
    return response;
  };

  static editProject = async (editProject: EditProject): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_PROJECT_URL, {
      ...editProject,
    });
    return response;
  };

  static toggleProjectIsActive = async (
    editProject: EditProject
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_PROJECT_IS_ACTIVE_URL,
      {
        ...editProject,
      }
    );
    return response;
  };

  static deleteProject = async (projectId: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_PROJECT_URL}/${projectId}`
    );
    return response;
  };
}

export default Project;

